import { render, staticRenderFns } from "./MessageHistory.vue?vue&type=template&id=cf452424"
import script from "./MessageHistory.vue?vue&type=script&lang=js"
export * from "./MessageHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf452424')) {
      api.createRecord('cf452424', component.options)
    } else {
      api.reload('cf452424', component.options)
    }
    module.hot.accept("./MessageHistory.vue?vue&type=template&id=cf452424", function () {
      api.rerender('cf452424', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/clients/components/MessageHistory.vue"
export default component.exports